import Store from 'store/store'
import { Component } from 'utils/jsx'

import Timeline from 'components/Timeline'

export default class App extends Component {
  template (props) {
    return (
      <main class='app' id='App'>
        <header class='app__header'>
          <h1 store-text={Store.filename} />
        </header>
        <Timeline />
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js